import { LegalLayout } from "../components/legal/LegalLayout";

const PoliticaPrivacidad = () => {
  return (
    <LegalLayout title="Política de privacidad" eyebrow="Protección de datos">
      <p>
        En cumplimiento del Reglamento (UE) 2016/679 General de Protección de
        Datos (RGPD) y de la Ley Orgánica 3/2018 de Protección de Datos
        Personales y Garantía de los Derechos Digitales (LOPDGDD), se informa
        al usuario sobre el tratamiento que el Titular del sitio web realiza de
        sus datos personales.
      </p>

      <h2>1. Responsable del tratamiento</h2>
      <ul>
        <li>
          <strong>Responsable:</strong> Aitor [Apellidos].
        </li>
        <li>
          <strong>NIF:</strong> [Pendiente de cumplimentar].
        </li>
        <li>
          <strong>Dirección:</strong> C/ Berriobide, Pamplona (Navarra),
          España.
        </li>
        <li>
          <strong>Email:</strong>{" "}
          <a href="mailto:contacto@aitornutricion.com">
            contacto@aitornutricion.com
          </a>
          .
        </li>
      </ul>

      <h2>2. Datos que tratamos</h2>
      <p>
        El sitio web es una landing de captación. <strong>No almacena datos personales en ninguna base de datos propia</strong>.
        Cuando el usuario rellena el formulario de contacto, los datos
        introducidos (nombre, email, teléfono y objetivo) se utilizan
        exclusivamente para componer un mensaje predefinido que se abre en la
        aplicación de WhatsApp del propio dispositivo del usuario, sin pasar
        por servidores del Titular.
      </p>
      <p>
        Una vez el usuario decide enviar (o no) ese mensaje a través de
        WhatsApp, los datos quedan únicamente en la conversación de WhatsApp
        entre el usuario y el Titular.
      </p>

      <h2>3. Finalidad del tratamiento</h2>
      <ul>
        <li>
          Atender consultas, solicitudes de información y gestionar el
          asesoramiento profesional en nutrición y entrenamiento.
        </li>
        <li>
          Mantener la comunicación profesional con el usuario a través de
          WhatsApp, email o teléfono.
        </li>
        <li>
          Cumplir con las obligaciones legales aplicables al Titular.
        </li>
      </ul>

      <h2>4. Base legal</h2>
      <p>
        La base jurídica para el tratamiento de los datos es el{" "}
        <strong>consentimiento expreso del interesado</strong> al enviar el
        formulario o iniciar la conversación por WhatsApp, así como el interés
        legítimo del Titular para la gestión de la relación profesional y, en
        su caso, la ejecución de un contrato de prestación de servicios.
      </p>

      <h2>5. Conservación de los datos</h2>
      <p>
        Los datos se conservarán durante el tiempo necesario para atender la
        consulta o relación profesional y, posteriormente, durante los plazos
        legalmente exigibles. El usuario puede solicitar su supresión en
        cualquier momento.
      </p>

      <h2>6. Destinatarios</h2>
      <p>
        Los datos no se cederán a terceros salvo obligación legal. La
        comunicación a través de WhatsApp implica el tratamiento de datos por
        parte de Meta Platforms Ireland Limited, en los términos descritos en
        su propia política de privacidad.
      </p>

      <h2>7. Derechos del usuario</h2>
      <p>
        El usuario puede ejercitar en cualquier momento los siguientes
        derechos:
      </p>
      <ul>
        <li>Acceso a sus datos personales.</li>
        <li>Rectificación de datos inexactos o incompletos.</li>
        <li>Supresión de los datos.</li>
        <li>Oposición y limitación del tratamiento.</li>
        <li>Portabilidad de los datos.</li>
        <li>Retirada del consentimiento prestado.</li>
      </ul>
      <p>
        Para ejercer estos derechos, puede dirigirse al Titular mediante email
        a{" "}
        <a href="mailto:contacto@aitornutricion.com">
          contacto@aitornutricion.com
        </a>
        , adjuntando copia de su DNI o documento equivalente.
      </p>
      <p>
        Asimismo, el usuario tiene derecho a presentar una reclamación ante la
        Agencia Española de Protección de Datos (AEPD,{" "}
        <a href="https://www.aepd.es" target="_blank" rel="noreferrer">
          www.aepd.es
        </a>
        ) si considera que sus derechos no han sido debidamente atendidos.
      </p>

      <h2>8. Cookies</h2>
      <p>
        El sitio web no utiliza cookies de seguimiento ni de analítica
        publicitaria. En caso de que en el futuro se incorporen, se publicará
        una política de cookies específica con la información detallada sobre
        las mismas y la posibilidad de aceptarlas o rechazarlas.
      </p>

      <h2>9. Seguridad</h2>
      <p>
        El Titular adopta las medidas técnicas y organizativas necesarias para
        garantizar la seguridad e integridad de los datos personales, evitando
        su pérdida, alteración o acceso no autorizado.
      </p>

      <h2>10. Modificaciones</h2>
      <p>
        El Titular se reserva el derecho de modificar la presente Política de
        Privacidad para adaptarla a novedades legislativas o jurisprudenciales,
        así como a las prácticas de la industria.
      </p>
    </LegalLayout>
  );
};

export default PoliticaPrivacidad;
